// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__31-FB","icono":"Navbar_icono__lyLnx","textSearch":"Navbar_textSearch__y3rom","botonera":"Navbar_botonera__3UPYj"};